import { useGetInfo } from '@ionic/react-hooks/device';
import { useEffect, useState } from 'react';

import { getDeviceInfo, isNative } from 'Util/Capacitors/SkooldioCapacitor';

const useGetDeviceInfo = () => {
  const { info } = useGetInfo();
  const [deviceInfo, setDeviceInfo] = useState(info || {});
  const isElectron = !!window.electron?.isElectron;

  useEffect(() => {
    if (isNative || isElectron) {
      getDeviceInfo()
        .then((deviceInfo) => {
          setDeviceInfo(deviceInfo);
        })
        .catch((error) => {
          console.error(error);
          setDeviceInfo({});
        });
    } else {
      setDeviceInfo(info || {});
    }
  }, [info, isElectron]);

  return deviceInfo;
};

export default useGetDeviceInfo;
